$(document).ready(function() {
  var $slider = $('.hc-images-carousel').not('.slick-initialized');
  var $hcFeaturedCol = $('.hc-featured-collection').not('.slick-initialized');

  $slider.slick({
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    prevArrow: '<div class="hc-arrow-left"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
    nextArrow: '<div class="hc-arrow-right"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $hcFeaturedCol.slick({
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<div class="hc-arrow-left"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
    nextArrow: '<div class="hc-arrow-right"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(window).on('resize orientationchange', function() {
    if ($slider.hasClass('slick-initialized')) $slider.slick('setPosition');
    if ($hcFeaturedCol.hasClass('slick-initialized')) $hcFeaturedCol.slick('setPosition');
  });
});

(function () {
  var $carousels = $('.hc-text-icons-carousel');
  var BREAKPOINT = 480; // px

  function init($el) {
    if ($el.hasClass('slick-initialized')) return;
    $el.slick({
      dots: false,
      adaptiveHeight: true,
      infinite: true,
      //autoplay: true,
      slidesToShow: 1,
      prevArrow: '<div class="hc-arrow-left"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></div>',
      nextArrow: '<div class="hc-arrow-right"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path></svg></div>'
    });
  }

  function destroy($el) {
    if ($el.hasClass('slick-initialized')) {
      $el.slick('unslick');
    }
  }

  function apply() {
    var isMobile = window.innerWidth <= BREAKPOINT;
    $carousels.each(function () {
      var $el = $(this);
      if (isMobile) init($el);
      else destroy($el);
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var ctx = this, args = arguments;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  $(apply); // on DOM ready
  $(window).on('resize orientationchange', debounce(apply, 150));
})();